import * as React from "react";
import DarkModeInverter from "nexia_mobile/components/DarkModeInverter";
import nexiaLogo from "nexia_mobile/styl/images/nexia_logo.svg";

const styles = {
  offcanvasLogo: {
    textAlign: "center",
    paddingTop: ".5em",
  },
  backgroundStyle: {
    display: "inline-block",
    backgroundSize: "100%",
    backgroundRepeat: "no-repeat",
    backgroundImage: `url(${nexiaLogo})`,
    width: "8em",
    height: "3.5em",
  },
};

const MainMenuBrandLogo = () => {
  return (
    <DarkModeInverter>
      {({ maybeInvert }) => {
        return (
          <div style={styles.offcanvasLogo}>
            <span
              data-component-name="MainMenuBrandLogo"
              style={{
                ...styles.backgroundStyle,
                ...maybeInvert,
              }}
            />
          </div>
        );
      }}
    </DarkModeInverter>
  );
};

export default MainMenuBrandLogo;



// WEBPACK FOOTER //
// ./src/components/BrandLogo/MainMenuBrandLogo.jsx